<template>
    <v-card class="px-9 py-8" color="primary darken-1" min-height="300">
        <v-row class="pa-0 ma-0">
            <v-col v-if="formInformationMessage" class="mb-3" cols="12">
                <div style="display: flex; align-items: center">
                    <v-icon class="mr-1" size="16">mdi-help-circle-outline</v-icon>
                    <span style="font-weight: normal;font-size: 14px;line-height: 18px;">{{formInformationMessage}}</span>
                </div>
            </v-col>
          <v-col class="hidden-sm-and-up" cols="12" style="min-width: 300px;">
            <v-btn class="button-text" style="font-weight: normal;font-size: 13px;line-height: 20px;" text @click="openMapDialog">
              <v-icon class="ml-n4" color="secondary lighten-1" size="20">mdi-map-marker-circle</v-icon>
              Visualizar as estações no mapa
            </v-btn>
          </v-col>

          <v-col cols="12" md="7">
            <h1 style="font-family: 'Roboto'; font-weight: normal; font-size: 16px; line-height: 20px;">Selecione uma estação</h1>
            <span style="font-family: 'Roboto'; font-style: normal; font-weight: 400; font-size: 14px; line-height: 18px;">Os dados disponíveis variam de estação para estação.</span>
          </v-col>

            <v-col :class="!breakpointIsSmall ? 'text-right hidden-xs-only' : 'hidden-xs-only'" cols="12" md="5" style="min-width: 300px;">
                <v-btn class="button-text" style="font-weight: normal;font-size: 16px;line-height: 20px;" text @click="openMapDialog">
                    <v-icon class="mr-2" color="secondary lighten-1" size="20">mdi-map-marker-circle</v-icon>
                    Visualizar as estações no mapa
                </v-btn>
            </v-col>

            <v-col cols="12">
                <v-form ref="form">
                    <v-autocomplete
                        v-model="station"
                        :items="items"
                        :filter="customFilter"
                        :loading="isLoading"
                        item-text="nome"
                        return-object
                        outlined
                        item-color="secondary lighten-1"
                        color="secondary lighten-1"
                        :rules="stationRules"
                        cache-items

                    >
                        <template v-slot:no-data>
                            <v-list-item>
                            <v-list-item-title>
                                <span class="error--text">Não encontrado.</span>
                            </v-list-item-title>
                            </v-list-item>
                        </template>

                        <template v-slot:item="{item}">
                            <div class="py-6" style="width: 100%;">
                                <h1 class="subtitle-1">{{item.nome}}</h1>
                                <div class="mt-3 text-left">
                                    <h3 class="caption mb-2">Dados disponíveis:</h3>
                                    <v-chip
                                        v-for="(sensor, indexSensor) in item.sensors"
                                        :key="indexSensor"
                                        outlined
                                        class="px-6 mr-2 mb-2"
                                        color="#168039"
                                        label
                                    >
                                        {{ getSensorDescription(sensor) }}
                                    </v-chip>
                                </div>
                            </div>
                        </template>
                    </v-autocomplete>
                </v-form>
            </v-col>

            <v-col cols="12" v-if="station">
                <h1 :class="showErrorMessageSensosrs ? 'error--text' : ''" style="font-weight: normal;font-size: 16px;line-height: 20px;">Sensores</h1>
                <h2 style="font-weight: normal;font-size: 14px;line-height: 18px;">Você pode selecionar até 2 sensores.</h2>

                <v-chip-group
                    class="py-1"
                    multiple
                    column
                    max="2"
                    v-model="sensorsSelected"
                >
                    <div class="text-center">
                        <v-chip
                            v-for="(sensor, index) in station.sensors"
                            :key="index"
                            :outlined="!sensorIndexIsSelected(index)"
                            :class="`px-6 secondary lighten-1 ${sensorIndexIsSelected(index) ? 'primary--text text--darken-1' : 'secondary--text text--lighten-1'}`"
                        >
                            <span style="font-weight: normal;font-size: 14px;line-height: 18px;">
                                {{ getSensorDescription(sensor)}}
                            </span>
                        </v-chip>
                    </div>
                </v-chip-group>
                <h2 v-if="showErrorMessageSensosrs" class="error--text" style="font-weight: normal;font-size: 14px;line-height: 18px;">Você precisa selecionar pelo menos um dos dados para fazer a consulta.</h2>
            </v-col>

            <div :class="this.$vuetify.breakpoint.name === 'xs' ? 'text-center' : 'mt-6 ml-3'">
                <v-btn class="button-text secondary lighten-1 primary--text text--darken-1 px-6 py-4" height="52" @click="loadData" :loading="loading" style="font-weight: normal;font-size: 16px;line-height: 20px;">
                    Consultar
                </v-btn>
                <v-btn class="ml-2 button-text secondary--text text--lighten-1" height="52" @click="clearForm" text>
                    Limpar formulário
                </v-btn>
                <v-btn class="ml-2 button-text secondary--text text--lighten-1" height="52" outlined @click="serieDownload" :loading="animation" :disabled="animation">
                  Série completa
                  <template v-slot:loader>
                    <span>Aguarde...</span>
                  </template>
                </v-btn>
                <div class="mt-4">
                  <h2 v-if="showErrorMessageStation" class="error--text" style="font-weight: normal;font-size: 16px;line-height: 20px;">Você precisa selecionar uma estação para fazer o download da série completa.</h2>
                  <h2 v-if="showErrorMessageSensor" class="error--text" style="font-weight: normal;font-size: 16px;line-height: 20px;">Você precisa selecionar pelo menos um dos sensores para fazer o download da série completa.</h2>
                </div>
            </div>
        </v-row>
    </v-card>
</template>

<script>
export default {
    name: "Stationform",
    props:{
        type:{
            type: String,
        },
        stations:{
            type: Array,
            required: true,
        },
        searchResult:{
            type: Object
        },
        formInformationMessage:{
            type: String,
            required: false,
        }
    },
    data: () => ({
        afterSearch: true,
        isLoading: false,
        search: undefined,
        items: [],
        station: undefined,
        sensorsSelected:[],
        stationRules: [
            v => !!v || 'Você precisa selecionar uma estação para fazer a consulta.'
        ],
        loading: false,
        animation: false,
        showErrorMessageSensosrs: false,
        showErrorMessageStation: false,
        showErrorMessageSensor: false,
    }),

    watch:{
        stations(listStations){
            if(listStations && listStations.length){
                this.station = listStations[0];
                this.items = this.stations;
            }
        },
        station(value){
            if(value){
              this.showErrorMessageStation = false;
              this.sensorsSelected = [];
            }
        },
        searchResult(value){
            if(value){
                this.loading = false;
            }
        },
      sensorsSelected(value){
          if (value.length) {
            this.showErrorMessageSensor = false;
          }

      }
    },

    computed:{
        breakpointIsSmall(){
            const breakpoint = this.$vuetify.breakpoint;
            return breakpoint.name === "xs" || breakpoint.name === "sm";
        }
    },

    methods:{
        async serieDownload(){
          if (this.station) {
            this.showErrorMessageStation = false;
            if (this.sensorsSelected.length) {
              this.showErrorMessageSensor = false;
              this.animation = true;
              let sensorOperationListIds = [];
              if (this.formInformationMessage) {
                for (let item in this.sensorsSelected) {
                  sensorOperationListIds.push(this.station.sensors[this.sensorsSelected[item]].codigo +'_'+this.station.sensors[this.sensorsSelected[item]].operation.codigo);
                }
                await this.$store.dispatch("loadCompleteSeries", { stationId: this.station.codigo, sensorOperationListIds: sensorOperationListIds, type: this.type } );
                await this.$store.getters.completeSeries;
              } else {
                for (let item in this.sensorsSelected) {
                  sensorOperationListIds.push(this.station.sensors[this.sensorsSelected[item]].codigo);
                }
                await this.$store.dispatch("loadCompleteSeries", { stationId: this.station.codigo, sensorListIds: sensorOperationListIds, type: this.type } );
                await this.$store.getters.completeSeries;
              }
              this.animation = false
            } else {
              this.showErrorMessageSensor = true;
            }
          } else {
            this.showErrorMessageStation = true;
          }
        },
        loadData(){
            const fieldsValidatedAndSensorsSelected = this.$refs.form.validate() && this.sensorsSelected.length;
            if(!fieldsValidatedAndSensorsSelected){
                this.showErrorMessageSensosrs = true;
                return;
            }
            this.showErrorMessageSensosrs = false;
            this.loading = true;
            const sensorsSelectedMap = this.mapSensorsFromlistSelected();
            const operationsMap = this.mapOperationsFromSensorsSelected();
            const sensor_ids = this.concatenateListIdsIntoString(sensorsSelectedMap, "codigo");
            let operation_ids = null;
            if (operationsMap != null && operationsMap[0] != null) {
                operation_ids = this.concatenateListIdsIntoString(operationsMap, "codigo");
            }
            const station_ids = this.station.codigo.toString();
            const formParams = { sensor_ids, operation_ids, station_ids };
            this.$emit("searchStationData", formParams);
        },

        clearForm(){
            this.$refs.form.reset();
            this.sensorsSelected = [];
        },

        sensorIndexIsSelected(sensorIndex){
            return this.sensorsSelected.find((sensorItem) => sensorItem === sensorIndex) !== undefined;
        },

        mapSensorsFromlistSelected(){
            return this.sensorsSelected.map((sensorSelectedIndex) => this.station.sensors[sensorSelectedIndex]);
        },

        mapOperationsFromSensorsSelected(){
            return this.sensorsSelected.map((sensorSelectedIndex) => this.station.sensors[sensorSelectedIndex].operation);
        },

        concatenateListIdsIntoString(list, keyName){
            return list.reduce((before, current)=>{
                const separateString = before ? "," : "";
                return `${before}${separateString}${current[keyName]}`;
            }, "");
        },

        getSensorDescription(sensor){
            if(this.type === "observado") return sensor.name;
            return sensor.descricao;
        },

        openMapDialog(){
            this.$emit("openMapDialog", true)
        },

        slugify(str) {
            str = str.toLowerCase();
            var from = "àáãäâèéëêìíïîòóõöôùúüûç"
            var to   = "aaaaaeeeeiiiiooooouuuuc"
            for (var i=0, l=from.length ; i<l ; i++) { str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i)) }
            return str
        },

        // eslint-disable-next-line no-unused-vars
        customFilter (item, queryText, itemText) {
            const searchText = this.slugify(queryText);
            const itemSlug = this.slugify(item.nome);
            return itemSlug.includes(searchText);
        },
    }
}
</script>

<style>
    .testchips{
        background-color: red !important;
    }
    .v-list-item--highlighted{
      background: rgba(96, 113, 219, 0.1) !important;
    }
    .theme--dark.v-list-item.v-list-item--highlighted::before {
      opacity: 0.05;
    }
</style>
